import * as React from "react";
import { Row, Divider, FormInstance, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { ColumnProps } from "antd/lib/table";
import { filePrintStore } from "../FilePrintStore";
import { projectsDataStore } from "Stores";
import { dayjs } from "Config/dayjs";
import { API_PrintJobRecipientWithfirstName } from "./RecipientDelivery";
import { Table } from "Components/General/Table";

interface ConfirmationProps extends WithTranslation {
  form: React.RefObject<FormInstance>;
  formData: API_PrintJob;
}
export const Confirmation = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ConfirmationProps> {
      private folding: Array<{ value: API_PRINTJOBFILE_FOLDING; name: string }> = [
        { value: "ROLLED", name: "rolled" },
        { value: "FILLING_20_MM", name: "filling margin 20 mm" },
        { value: "NO_FILLING", name: "no filling margin" },
        { value: "FILLING_STRIP", name: "filling strip" },
      ];

      private paper: Array<{ value: API_PRINTJOBFILE_PLOTTER; name: string }> = [
        { value: "BLACK_WHITE", name: "b/w on paper" },
        { value: "COLORED", name: "coloured on paper" },
        { value: "ORIGINAL", name: "like original on paper" },
        { value: "TRANSPARENT", name: "b/w on transparent" },
      ];

      get recipientsColumns(): ColumnProps<API_PrintJobRecipientWithfirstName>[] {
        const { t } = this.props;
        return [
          {
            title: t("Name"),
            dataIndex: "name",
            key: "name",
          },
          {
            title: t("Company"),
            dataIndex: "company",
            key: "company",
          },
          {
            title: t("Street"),
            dataIndex: "street",
            key: "street",
          },
          {
            title: t("Post code"),
            dataIndex: "postalCode",
            key: "postalCode",
          },
          {
            title: t("City"),
            dataIndex: "location",
            key: "location",
          },
          {
            title: t("Email"),
            dataIndex: "email",
            key: "email",
          },
        ];
      }

      get filesColumns(): ColumnProps<API_PrintJobFile>[] {
        const { t } = this.props;
        return [
          {
            title: t("Name"),
            dataIndex: "name",
            key: "name",
          },
          {
            title: t("Copies per recipient"),
            dataIndex: "copies",
            key: "copies",
          },
          {
            title: t("Copies in total"),
            dataIndex: "",
            key: "copiesTotal",
            render: (text, record) => record.copies * this.props.form.current.getFieldsValue().recipients?.length,
          },
          {
            title: t("Colours"),
            dataIndex: "plotter",
            key: "plotter",
            render: (text, record) => (record.plotter ? t(this.paper.find((plot) => plot.value === text).name) : null),
          },
          {
            title: t("Folding"),
            dataIndex: "folding",
            key: "folding",
            render: (text, record) =>
              record.folding ? t(this.folding.find((fold) => fold.value === text).name) : null,
          },
          {
            title: t("Scale"),
            dataIndex: "scale",
            key: "scale",
          },
        ];
      }

      render() {
        const { t } = this.props;
        const formData = this.props.formData;
        const { invoiceRecipient = {} } = formData || {};
        const provider = filePrintStore.plotProviders.find((item) => item.id === formData.providerId);

        return (
          <Row justify="space-between" align="middle">
            <div className="mb-lg fullWidth">
              <Divider orientation="horizontal">{t("Print job")}</Divider>
              <Form.Item label={t("Print supplier")} colon={true}>
                {provider ? provider?.name : null}
              </Form.Item>
              <Form.Item label={t("Project")} colon={true}>
                {projectsDataStore.currentProject.name}
              </Form.Item>
              <Form.Item label={t("Delivery date")} colon={true}>
                {dayjs(formData.deliveryDate).format("l")}
              </Form.Item>
              <Form.Item label={t("Customer Id")} colon={true}>
                {formData.orderParty?.contactId}
              </Form.Item>
              <Form.Item label={t("Contact person")} colon={true}>
                {formData.orderParty?.name}
              </Form.Item>
              <Form.Item label={t("Email")} colon={true}>
                {formData.orderParty?.email}
              </Form.Item>
              <Form.Item label={t("Invoice address")} colon={true}>
                {`${invoiceRecipient.name}, ${invoiceRecipient.street}, ${invoiceRecipient.postalCode} ${invoiceRecipient.location}, ${invoiceRecipient.company}`}
              </Form.Item>
            </div>
            {!filePrintStore.usedForDisitibutionMatrix && (
              <>
                <div className="mb-lg fullWidth">
                  <Divider orientation="horizontal">{t("Recipients")}</Divider>
                  <Table
                    name="printRecipients"
                    style={{ width: "100%" }}
                    dataSource={formData.recipients}
                    columns={this.recipientsColumns}
                    rowKey={(record) => `${record.id}`}
                    pagination={formData.recipients?.length < 11 ? false : undefined}
                  />
                </div>
                <div className="mb-lg fullWidth">
                  <Divider orientation="horizontal">{t("Files")}</Divider>
                  <Table
                    name="printFiles"
                    style={{ width: "100%" }}
                    dataSource={formData.files}
                    columns={this.filesColumns}
                    rowKey={(record) => `${record.id}`}
                    pagination={formData.files?.length < 11 ? false : undefined}
                  />
                </div>
              </>
            )}
          </Row>
        );
      }
    }
  )
);
